/**
 * Single source of truth for the offline workout logging flag
 * (offline_workout_logging, release, OFF by default). Reads the server-injected
 * `window._tkcEnabledFeatures` list, like services/share/shareFeature.js.
 *
 * Off means every offline module is inert: no interceptor queues anything, no
 * idempotency header is sent, no indicator is drawn, and requests fail exactly
 * as they did before.
 * @returns {boolean}
 */
export const isOfflineLoggingEnabled = () =>
  window._tkcEnabledFeatures?.includes("offline_workout_logging") ?? false;
